import type { AddressTypes } from '#components/order/CreateOrderDialog/LocationForm.tsx';
import type { StopType } from '#domain/Stop.ts';

export const mapStopTypeToAddressType = (stopType?: StopType): AddressTypes => {
    if (stopType === 'load') {
        return 'loadingStop';
    }
    if (stopType === 'execute') {
        return 'executionStop';
    }
    return 'unloadingStop';
};
